import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { messages } from "@/locales/en/messages";
import { StatusBarProvider } from "./contexts/StatusBarContext";
import StatusBar from "./components/StatusBar";

i18n.load("en", messages);
i18n.activate("en");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <StatusBarProvider>
        <App />
        <StatusBar />
      </StatusBarProvider>
    </I18nProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
